import { render } from "./CallbackDosi.vue?vue&type=template&id=12e0a9f3&scoped=true"
import script from "./CallbackDosi.vue?vue&type=script&lang=js"
export * from "./CallbackDosi.vue?vue&type=script&lang=js"

import "./CallbackDosi.vue?vue&type=style&index=0&id=12e0a9f3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e0a9f3"]])

export default __exports__